import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getServiceCategories = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/service-categories`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getServiceCategoryById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/service-categories/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createServiceCategory = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/service-categories`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateServiceCategory = (id: number, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/service-categories/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deleteServiceCategory = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .delete(`${BASE_URL}/api/v1/service-categories/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
